export default "__VITE_ASSET__DR6xBDj1__"